import { PaletteMode } from "@mui/material";
import { Theme, ThemeOptions } from "@mui/material/styles";
import React from "react";

export const ColorModeContext = React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleColorMode: () => {}
});

declare module "@mui/material/styles" {
  interface MyTheme extends Theme {
    bgs: {
      transparent: React.CSSProperties["color"];
      weekend: React.CSSProperties["color"];
    };
  }

  interface Palette {
    bgs: Palette["primary"];
  }
  interface PaletteOptions {
    bgs: PaletteOptions["primary"];
  }

  interface PaletteColor {
    transparent?: string;
    weekend?: string;
  }
  interface SimplePaletteColorOptions {
    transparent?: string;
    weekend?: string;
  }
  interface MyThemeOptions extends ThemeOptions {
    bgs: {
      transparent: React.CSSProperties["color"];
      weekend: React.CSSProperties["color"];
    };
  }
}
export interface MyThemeOptions extends ThemeOptions {
  bgs: {
    transparent: React.CSSProperties["color"];
    weekend: React.CSSProperties["color"];
  };
}

export const vacationColor = "#8b01f1";
export const hoursOffColor = "#1a9ff8";
export const isSickColor = "#f1b901";
export const correctPuncesColor = "#0dbb2a";
export const missingPuncesColor = "#e42525";
export const darkMainColor = "#001529";
// const lightText = "#001529";

// A custom theme for this app
export const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...(mode === "light"
      ? {
          // palette values for light mode
          primary: {
            main: "#e7344c"
          },
          secondary: {
            main: darkMainColor
          },
          text: {
            primary: darkMainColor
          },
          background: {
            default: "#fff",
            paper: "#efefef"
          },
          bgs: {
            transparent: "rgba(239, 239, 239, 0.8)",
            weekend: "#ddd"
          }
        }
      : {
          // palette values for dark mode
          primary: {
            main: "#e7344c"
          },
          secondary: {
            main: "#fff"
          },
          background: {
            default: darkMainColor,
            paper: "#001122"
          },
          bgs: {
            transparent: "rgba(0, 17, 34, 0.8)",
            weekend: "#000d1a"
          }
        })
  }
});
// const theme = createTheme(getDesignTokens("dark") as MyThemeOptions);
// export default theme;
